/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// Core - Breadcrumb Component
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import config from "../../service/config";
import uiConfig from "../../uiConfig";
import right_arrow from "../../assets/img/breadcrumb_rightarrow.png";
// Imported Component
import Icons from "../Icons";
import { truncateStr } from "../../pages/helper";
import { arabicContent } from "../../constants/index";

const LinkItem = ({
  title,
  path,
  testId,
  state,
  isLastIndex,
  goback,
  innerWidth
}) => {
  let pathname = (title === "all offers" || title === "nearby_offers") ? title : path;
  if (!pathname) {
    return (
      <>
        {config.clientName === "ADIB" &&
        title &&
        title !== null &&
        isLastIndex ? (
          <div className="bcm-lnk last">{title}</div>
        ) : (
          <div
            className="bcm-lnk"
            style={{
              color:
                uiConfig.config.whitelabel.merchant_details.merchant_tile.color
            }}
          >
            {title}
          </div>
        )}
        {title && title !== null && !isLastIndex && (
          <div className="bcm-spl">
            {config.clientName === "ADIB" ? (
              <span className="bc_spl">/</span>
            ) : localStorage.getItem("language") === "AR" ? (
              <Icons
                fill={
                  uiConfig.config.whitelabel.merchant_details.merchant_tile
                    .color
                }
                name="arrowLeft"
                width={14}
                height={10}
              />
            ) : innerWidth > 768 ? (
              <span className="bc_spl">
                &nbsp;
                <img
                  style={{ display: "inline"}}
                  src={right_arrow}
                  alt="rightarr"
                />
                &nbsp;
              </span>
            ) : (
              <span className="bc_spl">&#160;/</span>
            )}
          </div>
        )}
      </>
    );
  }
  return (
    <>
      {title && title !== null && (
        <div
          className="bcm-lnk cursor"
          style={
            config.clientName === "ADIB"
              ? {}
              : {
                  color:
                    uiConfig.config.whitelabel.merchant_details.merchant_tile
                    .color,
                    cursor: title==="financial products" && "auto"
                }
          }
          data-testid={testId}
          // to={{
          //   pathname: path,
          //   state
          // }}
          onClick={() => title!=="financial products" && goback(pathname)}
          title={title}
        >
          {title}
        </div>
      )}
      {title && title !== null && !isLastIndex && (
        <div className="bcm-spl">
          {config.clientName === "ADIB" ? (
            <span
              className={`bc_spl ${
                localStorage.getItem("language") === "AR" ? "ar" : ""
              }`}
            >
              /
            </span>
          ) : localStorage.getItem("language") === "AR" ? (
            <Icons
              fill={
                uiConfig.config.whitelabel.merchant_details.merchant_tile.color
              }
              name="arrowLeft"
              width={14}
              height={10}
            />
          ) : innerWidth > 768 ? (
            <span className="bc_spl">
              &nbsp;
              <img
                style={{ display: "inline"}}
                src={right_arrow}
                alt="rightarr"
              />
              &nbsp;
            </span>
          ) : (
            <span className="bc_spl">&#160;/</span>
          )}
        </div>
      )}
    </>
  );
};

// Main Component
const Breadcrumb = ({ fromPage, links, goback, isSimilar, len = 0 }) => {
  const myContainer = useRef(null);
  const [data, setData] = useState(links);
  var counter = links.length - (fromPage === "home") ? 1 : 2;
  const [innerwidth, setWidth] = useState(window.innerWidth);
  let titleLen = 100
  let textlen = 100

if (window.matchMedia('(min-width: 1900px)').matches) {  // check screen size and alter txtlen accordingly

  titleLen = 200;
  textlen = 250

}

else if (window.matchMedia('(min-width: 1700px)').matches) {  // check screen size and alter txtlen accordingly

  titleLen = 180;
  textlen = 200

} else if (window.matchMedia('(min-width: 1600px)').matches) {  // check screen size and alter txtlen accordingly

  titleLen = 110;
  textlen = 140

} else if (window.matchMedia('(min-width: 1500px)').matches) {

  

  titleLen = 150;
  textlen = 170

} else if (window.matchMedia('(min-width: 1400px)').matches) {

 

  titleLen = 140;
  textlen = 160

} else if (window.matchMedia('(min-width: 1300px)').matches) {

  titleLen = 125;
  textlen = 160

} else if (window.matchMedia('(min-width: 1250px)').matches) {

  titleLen = 120;
  textlen = 145

}

 else if (window.matchMedia('(min-width: 1100px)').matches) {

  titleLen = 100;
  textlen = 130

}  else if (window.matchMedia('(min-width: 1000px)').matches) {

  titleLen = 80;
  textlen = 110

}

else if (window.matchMedia('(min-width: 768px)').matches) {

 

  titleLen = 50;
  textlen = 80

}

  function checkOverflow(el) {
    var curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    var isOverflowing =
      el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  const updateMedia = () => {
    setWidth(window.innerWidth);
  };

  // const updatelinks = (data) => {
  //   if (isSimilar) {
  //     setData(data);
  //   }
  //   if (checkOverflow(myContainer.current)) {
  //     if (data[counter] && counter != 0 ) {
  //       if(fromPage === "home" & data.length > 2){
  //         if(innerwidth > 768){
  //           data[1].title = data[1].title;
  //           data[2].title = data[2].title;
  //         }
  //         else if(data[3]?.title.length < 6){
  //           data[1].title =  (data[1].title?.length > 9 ) ? "..." : data[1]?.title ;
  //           data[2].title = "...";
  //         }
  //         else{
  //           data[1].title = "...";
  //           data[2].title = "...";
  //         }
  //       }
  //       else if(!isSimilar){
  //         data[counter].title = "...";
  //       }
  //       setCounter(counter - 1);
  //       setData(data);
  //     } else {
  //       data[links.length - 1].title = truncateStr(
  //         data[links.length - 1].title,
  //         13
  //       );
  //       setData(data);
  //     }
  //   }
  // }
  const updatedata = (links) => {
    //claimed , wishlist paths = 2
    //home path = 4
    //home (using back button) =2
    //similar merchant = 3
    let data = [];
    let locationNearme = false;
    let selCity = JSON.parse(localStorage.getItem("selectCountry"));
    if (["Near me", arabicContent.nearMe].includes(selCity.value)) {
      locationNearme = true;
      data = links.filter(({ title }) => title !== selCity.value);
    } else {
      data = links;
    }
    if (checkOverflow(myContainer.current)) {
      if ((fromPage === "home") & (data.length > 3)) {
        if (innerwidth > 768) {
          data[1].title = data[1].title;
          data[2].title = data[2].title;
          data[3].title =  truncateStr(data[3]?.title, titleLen);
        } else if (data[3]?.title.length < 6) {
          data[1].title = data[1].title?.length > 9 ? "..." : data[1]?.title;
          data[2].title = "...";
        } else {
          data[1].title = "...";
          if (locationNearme) {
            data[2].title = truncateStr(data[2].title, 13);
          } else {
            data[2].title = "...";
            data[3].title = truncateStr(data[3]?.title, 13);;
          }
        }
      }
      else if((fromPage === "home") & (data.length == 3)){
        if (innerwidth > 768) {
          data[1].title = data[1].title;
          data[2].title = truncateStr(data[2].title, titleLen)
          // data[3].title =  truncateStr(data[3].title, titleLen);
        } else if (data[2]?.title.length < 6) {
          data[1].title = data[1].title?.length > 9 ? "..." : data[1]?.title;
          data[2].title = data[2].title;
        } else {
          data[1].title = "...";
          if (locationNearme) {
            data[2].title = truncateStr(data[2].title, 13);
          } 
        }
      }
         else if ((fromPage === "home") & (data.length < 3)) {
        data[1].title = data[1].title;
      } else if (isSimilar & (data[1].title !== undefined)) {
        if (innerwidth < 768) {
          data[1].title = truncateStr(data[1].title, 13);
          data[2].title = truncateStr(data[2].title, 13);
        } else if (innerwidth < 768) {
          data[2].title = truncateStr(data[2].title, 13);
        }
      } else {
        if (innerwidth < 768) {
          data[data.length - 1].title = truncateStr(
            data[data.length - 1].title,
            13
          );
        }
        else{

          data[2].title = truncateStr(data[2].title, textlen);

        }
      }
    }
    counter -= 1;
    return data;
  };

  useEffect(() => {
    setData(updatedata(links));
  }, [links, counter]);

  return (
    <div
      className="bcm"
      data-testid="bcm"
      ref={myContainer}
      style={{ width: `0px` }}
    >
      {data.map((link, idx) => (
        <LinkItem
          key={`link-${idx}`}
          title={link.title}
          state={link.state}
          path={link.path}
          isLastIndex={data.length - 1 === idx}
          goback={goback}
          innerWidth={innerwidth}
        />
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array
};

Breadcrumb.defaultProps = {
  title: "",
  links: []
};

export default Breadcrumb;
